import { Api, IApiResponse } from '../api';
import { AppTourStateDto, AppTourStateUpdateRequestDto } from '../models';

export const get = (): Promise<IApiResponse<AppTourStateDto>> => Api.get('app-tour');

export const update = (requestedState: AppTourStateUpdateRequestDto) => Api.put('app-tour', requestedState);
